import type { SVGProps } from 'react';
export const FitToScreen = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M17 5.1v9.8q0 .46-.32.78-.31.31-.76.32H4.08q-.45 0-.76-.32a1 1 0 0 1-.32-.77V5.09q0-.45.32-.77.31-.31.76-.32h11.84q.45 0 .76.32t.32.77m-1.08 9.8V5.1H4.08v9.8z" />
    <path
      fillRule="evenodd"
      d="M5.15 11.45c0-.3.24-.54.54-.54h2.16q.22 0 .38.16.15.16.15.38v2.19c0 .3-.24.54-.53.54a.54.54 0 0 1-.54-.54V12H5.69a.54.54 0 0 1-.54-.55"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.15 6.18c.3 0 .54.25.54.55v1.63h1.62c.3 0 .54.25.54.55s-.24.54-.54.54h-2.16a.54.54 0 0 1-.53-.54V6.73c0-.3.24-.55.53-.55"
      clipRule="evenodd"
    />
  </svg>
);
